import React from 'react'
import styles from './TopicBanner.module.css'

const TopicBanner = ({ selectedTopic, onClose }) => {
  if (!selectedTopic) return null

  const getTopicMessage = (topicId) => {
    switch (topicId) {
      case 'htp-house':
        return '집을 그려주세요'
      case 'htp-tree':
        return '나무를 그려주세요'
      case 'htp-human':
        return '사람을 그려주세요'
      case 'pitr':
        return '빗속의 사람을 그려주세요'
      default:
        return '그림을 그려주세요'
    }
  }

  return (
      <div className={styles.bannerContent}>
        <span className={styles.bannerText}>
          {getTopicMessage(selectedTopic.id)}
        </span>
      </div>
  )
}

export default TopicBanner